class Modal {
  constructor(modal, trigger) {
    this.$modal = modal;
    this.$trigger = trigger;
    this.$close = this.$modal.querySelector('.modal-close');
    this.$image = this.$modal.querySelector('img');

    this.init();
  }

  init() {
    this.$trigger.addEventListener('click', () => {
      this.show();
    })

    if (this.$close) {
      this.$close.addEventListener('click', () => {
        this.hide();
      })
      this.$modal.addEventListener('click', (ev) => {
        if(!ev.target.classList.contains('modal-content')){
          this.hide();
        }
      })
    }
  }

  show() {
    if(this.$image && this.$image.dataset.src){
      this.$image.src = this.$image.dataset.src;
    }
    this.$modal.classList.add('open');
    document.body.classList.add('no-scroll')
  }

  hide() {
    this.$modal.classList.remove('open');
    document.body.classList.remove('no-scroll')
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./scripts/libs/Modal.js